import { UpsellProduct } from '@moonpig/web-shared-products'
import { ProductWithRecommendations } from '../../components/ProductDetails'
import { DepartmentInfo } from '../../types'

export enum ProductDetailsStateActionTypes {
  SET_SELECTED_VARIANT = 'SET_SELECTED_VARIANT',
  SET_PRODUCT = 'SET_PRODUCT',
  SET_QUANTITY = 'SET_QUANTITY',
  SET_ADDON_SKU = 'SET_ADDON_SKU',
}

export type ActionSetSelectedVariant = {
  type: ProductDetailsStateActionTypes.SET_SELECTED_VARIANT
  payload: string
}

export type ActionSetProduct = {
  type: ProductDetailsStateActionTypes.SET_PRODUCT
  payload: ActionSetProductPayload
}

export type ActionSetProductPayload = {
  product: ProductWithRecommendations
  useMasterVariantAsDefault: boolean
  upsellProduct?: UpsellProduct
  departmentInfo: DepartmentInfo
}

export type ActionSetQuantity = {
  type: ProductDetailsStateActionTypes.SET_QUANTITY
  payload: number
}

export type ActionSetAddonSku = {
  type: ProductDetailsStateActionTypes.SET_ADDON_SKU
  payload: string | null
}

export type ProductDetailsStateAction =
  | ActionSetSelectedVariant
  | ActionSetProduct
  | ActionSetQuantity
  | ActionSetAddonSku

export type SelectedOptions = {
  variantKey: string
  quantity: number
  addonSku: string | null
}

export type ProductDetailsState = {
  product: ProductWithRecommendations
  upsellProduct?: UpsellProduct
  selectedOptions: SelectedOptions
  departmentInfo: DepartmentInfo
}

export type ProductDetailsContext = [
  ProductDetailsState,
  React.Dispatch<ProductDetailsStateAction>,
]
